'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SPAM = exports.SPAM = 'SPAM';
var BLOCK = exports.BLOCK = 'BLOCK';